import React from 'react';
import './App.css';

const navLinks = [
  { label: 'Case Studies', href: 'https://www.nextgencodingcompany.com/case-studies/' },
  { label: 'ERP', href: 'https://solutions.nextgencodingcompany.com/erp' },
  {
    label: 'Regulatory Compliance',
    href: 'https://solutions.nextgencodingcompany.com/compliance/home/index.html'
  }
];

const offerings = [
  {
    title: 'Product Engineering',
    text: 'Custom web and mobile products designed, built, and shipped with speed and reliability.'
  },
  {
    title: 'AI & Automation',
    text: 'Intelligent workflows, copilots, and automation systems that reduce manual effort.'
  },
  {
    title: 'Cloud Architecture',
    text: 'Secure, scalable cloud foundations for modern apps, data, and distributed teams.'
  },
  {
    title: 'UX & Interface Design',
    text: 'Human-centered experiences with strong visual identity, accessibility, and conversion focus.'
  },
  {
    title: 'Data & Analytics',
    text: 'Dashboards and pipelines that transform business signals into decisions.'
  },
  {
    title: 'DevOps & CI/CD',
    text: 'Release pipelines, observability, and infrastructure automation for confident deployments.'
  },
  {
    title: 'Quality Engineering',
    text: 'Test strategy and automated coverage to keep delivery fast without sacrificing trust.'
  },
  {
    title: 'Security & Compliance',
    text: 'Practical security controls and compliance workflows integrated directly into delivery.'
  }
];

const footerNavLinks = [
  { label: 'Home', href: 'https://www.nextgencodingcompany.com/' },
  { label: 'Services', href: 'https://www.nextgencodingcompany.com/services/' },
  { label: 'Case Studies', href: 'https://www.nextgencodingcompany.com/case-studies/' },
  { label: 'Technologies', href: 'https://www.nextgencodingcompany.com/technology/' },
  { label: 'Research', href: 'https://www.nextgencodingcompany.com/research/' },
  { label: 'Contact', href: 'https://www.nextgencodingcompany.com/contact/' },
  { label: 'About', href: 'https://www.nextgencodingcompany.com/about/' },
  { label: 'Partnerships', href: 'https://www.nextgencodingcompany.com/partnerships/' },
  { label: 'Industries', href: 'https://www.nextgencodingcompany.com/industries/' },
  { label: 'Sales', href: 'https://www.nextgencodingcompany.com/sales/' }
];

const socialLinks = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/nextgen-coding-company/', icon: 'in' },
  { label: 'X', href: 'https://x.com/NextGenCodingCo', icon: '𝕏' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@nextgen_coding_company', icon: '♪' },
  { label: 'Instagram', href: 'https://www.instagram.com/nextgencodingcompany/', icon: '◉' },
  { label: 'YouTube', href: 'https://www.youtube.com/@NextGenCodingCompany', icon: '▶' },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61565877998889', icon: 'f' }
];

function App() {
  return (
    <div className="coming-soon-page">
      <div className="bg-glow bg-glow-a" aria-hidden="true" />
      <div className="bg-glow bg-glow-b" aria-hidden="true" />
      <div className="bg-grid" aria-hidden="true" />

      <nav className="top-nav" aria-label="Primary Navigation">
        <a className="brand" href="https://www.nextgencodingcompany.com/" target="_blank" rel="noreferrer">
          <img src="/nextgen-logo.png" alt="NextGen Coding Company logo" className="brand-logo" />
          <span className="brand-text">NextGen Coding Company</span>
        </a>

        <div className="top-nav-links">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`top-nav-link ${link.label === 'Case Studies' ? 'active' : ''}`}
              target="_blank"
              rel="noreferrer"
            >
              {link.label}
            </a>
          ))}
        </div>
      </nav>

      <header className="hero">
        <p className="hero-kicker">Case Study Series: New Experience in Production</p>
        <h1>Coming Soon</h1>
        <p className="hero-copy">
          This experience extends NextGen Coding Company solutions and highlights practical
          business platforms such as ERP systems, compliance tools, and enterprise automation.
        </p>
        <a
          href="https://www.nextgencodingcompany.com/case-studies/"
          className="hero-cta"
          target="_blank"
          rel="noreferrer"
        >
          View Offerings
        </a>
      </header>

      <main id="offerings" className="offerings-section">
        <div className="section-title-wrap">
          <p className="section-label">All Offerings</p>
          <h2>What We Build & Deliver</h2>
        </div>

        <div className="offerings-grid">
          {offerings.map((offering) => (
            <article className="offering-card" key={offering.title}>
              <h3>{offering.title}</h3>
              <p>{offering.text}</p>
            </article>
          ))}
        </div>
      </main>

      <footer className="site-footer">
        <div className="footer-top">
          <div className="footer-brand-section">
            <a href="https://www.nextgencodingcompany.com/" className="footer-brand" target="_blank" rel="noreferrer">
              <img src="/nextgen-logo.png" alt="NextGen Coding Company logo" className="footer-logo" />
              <span>&lt;Code The Future /&gt;</span>
            </a>
          </div>

          <div className="footer-cta-section">
            <a className="footer-cta-btn" href="https://www.nextgencodingcompany.com/contact/" target="_blank" rel="noreferrer">
              Contact Us
            </a>
            <a className="footer-cta-link" href="https://docsend.com/v/q5fpj/nextgen-coding-company-capability-statement" target="_blank" rel="noreferrer">
              Capability Statement
            </a>
          </div>

          <div className="footer-social">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noreferrer"
                title={link.label}
                aria-label={link.label}
                className="social-link"
              >
                <span className="social-icon">{link.icon}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="footer-content">
          <div className="footer-description">
            <p>
              At NextGen Coding Company, we drive the technological revolution with innovative solutions
              across Artificial Intelligence (AI), Machine Learning (ML), Blockchain, Computer Vision,
              and Automation. Our mission is to empower businesses with transformative digital services
              that tackle complex challenges and create new opportunities for growth. By delivering
              cutting-edge expertise and staying at the forefront of technological advancements, we inspire
              progress and foster digital transformation, shaping a smarter, more connected world. At NextGen,
              we're not just solving today's problems — we're building the foundation for the future.
            </p>
          </div>

          <div className="footer-contact-info">
            <p className="footer-address">150 Wrenn Dr PO Box 187<br />Cary, NC 27513</p>
            <p className="footer-phone"><a href="tel:+19193427602">(919) 342-7602</a></p>
          </div>
        </div>

        <div className="footer-nav-grid">
          {footerNavLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className="footer-nav-link"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="footer-legal">
          <p>&copy; 2026 Next Gen Coding Company, Inc.</p>
          <div className="footer-legal-links">
            <a href="https://www.nextgencodingcompany.com/privacy-policy/" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
            <a href="https://www.nextgencodingcompany.com/terms-of-use/" target="_blank" rel="noreferrer">
              Terms of Use
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
